// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39kxQ","title":"styles_title__1XBiL"};